module.exports = __webpack_public_path__ + "static/media/ic_humburger.0f12b5dd.svg";